import { mapTeamResponseDto } from 'modules/teams/domain/data-mappers/response-dto';
import { GetTeamByIdResponseDto } from 'modules/teams/domain/interfaces/response-dto';
import { Team } from 'modules/teams/domain/interfaces/team';
import { baseApi } from 'shared/api/base-api';

/**
 * Всё, что нужно карточке команды, одним запросом: основные данные, форма,
 * состав с ролями и заявки на вступление. Раньше страница делала три запроса
 * к одному и тому же полю `team(id)`.
 */
const GET_TEAM_BY_ID_QUERY = `#graphql
  query getTeamById($id: Int!) {
    team(id: $id) {
      id
      name
      shortName
      createdAt
      emblem {
        id
        externalUrl
      }
      tournament {
        sportType
      }
      kits {
        id
        type
        elements {
          element
          attributes {
            pattern
            colors
          }
        }
      }
      members {
        id
        number
        position
        role
        createdAt
        user {
          id
          name
          surname
          middleName
          birthDate
          height
          weight
          isReal
          photo {
            id
            externalUrl
          }
        }
      }
      entryRequests {
        id
        status
        createdAt
        requestingUser {
          id
          name
          surname
          middleName
          birthDate
          height
          weight
          createdAt
          photo {
            id
            externalUrl
          }
        }
      }
    }
  }
`;

/**
 * Экспортируется для юнит-тестов. `team(id:)` в схеме nullable, поэтому удалённая
 * команда даёт `null`, а не исключение внутри transformResponse.
 */
export function mapGetTeamByIdResponse(raw: GetTeamByIdResponseDto): Team | null {
  return raw?.team ? mapTeamResponseDto([raw.team])[0] : null;
}

export const teamsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTeamById: build.query<Team | null, number>({
      query: (id) => ({ query: GET_TEAM_BY_ID_QUERY, variables: { id } }),
      transformResponse: mapGetTeamByIdResponse,
      providesTags: (_result, _error, id) => [{ type: 'Team', id }],
      keepUnusedDataFor: 120,
    }),
  }),
  overrideExisting: false,
});

export const { useGetTeamByIdQuery, useLazyGetTeamByIdQuery } = teamsApi;
